<template>
    <div id="document-printer" class="print" v-if="print_trigger" :style="{
        width: paper_width + 'mm',
        overflowX: 'hidden'
    }">
        <div v-for="(document, index) in documents" class="left-floated">
            <span v-html="document.html"></span>
            <div v-if="(index + 1) % numbers_of_one_page == 0" style="clear: both;break-after: always;page-break-after: always; padding:0;margin:0;"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DocumentPrinter",
    props: {
        width: {
            default: 210,
            type: Number
        },
        paper_type: {
            default: "A4",
            type: String
        },
        numbers_of_one_page: {
            default: 1,
            type: Number
        },
        documents: Array
    },
    data() {
        return {
            print_trigger: false
        }
    },
    mounted() {
        this.$bus.$off('print_document')
        this.$bus.$on('print_document', () => {
            this.print_trigger = false
            this.print_trigger = true
        })
        this.$bus.$on('cancel_print_document', () => {
            this.print_trigger = false
        })

        this.$nextTick(() => {
            this.handle_print()
        })
    },
    watch: {
        print_trigger() {
            this.$nextTick(() => {
                this.handle_print()
            })
        }
    },
    computed: {
        paper_width() {
            switch (this.paper_type) {
                case "100x100":
                    var paper_width = 100
                    break
                case "A4":
                    var paper_width = 210
                    break
                case "A5":
                    var paper_width = 210
                    break
                default:
                    var paper_width = this.paper_type
            }
            return paper_width
        }
    },
    methods: {
        handle_print() {
            if (this.print_trigger) {
                this.print_trigger = false
                if (ENV.VUE_APP_BUILD_ENV == 'electron') {
                    let web_content = BrowserWindow.getFocusedWindow().webContents
                    web_content.print({ silent: true })
                } else {
                    window.print()
                }
            }
        }
    },
    components: {
    }
}
</script>

<style scoped>
.left-floated {
    float: left;
}
</style>
